import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getSesConfigurationState = createSelector(
  getDragonflyState,
  (state) => state?.sesConfiguration,
);

export const getNameSes = createSelector(getSesConfigurationState, (state) => state?.nameSes);

export const getStatusSes = createSelector(getSesConfigurationState, (state) => state?.isActiveSes);

export const getDisableNameValue = createSelector(
  getSesConfigurationState,
  (state) => state?.disableName,
);

export const getIntegrationConfHelpTextStatus = createSelector(
  getSesConfigurationState,
  (state) => state?.integrationConfHelpTextStatus,
);

export const getCampaignReportingHelpTextStatus = createSelector(
  getSesConfigurationState,
  (state) => state?.campaignReportingHelpTextStatus,
);

export const getSenderNamesSes = createSelector(
  getSesConfigurationState,
  (state) => state?.senderNamesSes,
);

export const getSenderEmailAddressesSes = createSelector(
  getSesConfigurationState,
  (state) => state?.senderEmailAddressesSes,
);

export const getConfigurationSetsSes = createSelector(
  getSesConfigurationState,
  (state) => state?.configurationSetsSes,
);

export const getLookBackDaysSes = createSelector(
  getSesConfigurationState,
  (state) => state?.lookBackDaysSes,
);

export const getSesDataIsSubmitted = createSelector(
  getSesConfigurationState,
  (state) => state?.isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(
  getNameSes,
  getSesDataIsSubmitted,
  (name, dataIsSubmitted) => (!name && dataIsSubmitted ? true : false),
);

export const getShowLookBackDaysErrorMsg = createSelector(
  getLookBackDaysSes,
  getSesDataIsSubmitted,
  (lookBackDays, dataIsSubmitted) => (lookBackDays === null && dataIsSubmitted ? true : false),
);

export const getShowUpdateBtn = createSelector(
  getSesConfigurationState,
  (state) => state?.showUpdateBtn,
);

export const getShowCancelBtn = createSelector(
  getSesConfigurationState,
  (state) => state?.showCancelBtn,
);

export const getAreSenderNamesValid = createSelector(getSenderNamesSes, (senderNames) =>
  (senderNames ?? []).map((value) => value !== ''),
);

export const getAreSenderEmailsValid = createSelector(getSenderEmailAddressesSes, (senderEmails) =>
  (senderEmails ?? []).map((value) => value !== ''),
);

export const getAreConfSetsValid = createSelector(getConfigurationSetsSes, (confSets) =>
  (confSets ?? []).map((value) => value !== ''),
);

export const getSesDataAreValid = createSelector(
  getNameSes,
  getAreSenderNamesValid,
  getAreSenderEmailsValid,
  getAreConfSetsValid,
  getLookBackDaysSes,
  (name, senderNamesValid, senderEmailsValid, confSetsValid, lookBackDays) => {
    const hasInvalidSenderName = senderNamesValid.includes(false);
    const hasInvalidSenderEmail = senderEmailsValid.includes(false);
    const hasInvalidConfSet = confSetsValid.includes(false);

    return (
      name &&
      !hasInvalidSenderName &&
      !hasInvalidSenderEmail &&
      !hasInvalidConfSet &&
      lookBackDays !== null
    );
  },
);

export const getShowSenderNamesErrorMsg = createSelector(
  getSenderNamesSes,
  getSesDataIsSubmitted,
  (senderNames, dataIsSubmitted) => {
    return senderNames.map((name) => dataIsSubmitted && name === '');
  },
);

export const getShowSenderEmailsErrorMsg = createSelector(
  getSenderEmailAddressesSes,
  getSesDataIsSubmitted,
  (senderEmails, dataIsSubmitted) => {
    return senderEmails.map((email) => dataIsSubmitted && email === '');
  },
);

export const getShowConfSetsErrorMsg = createSelector(
  getConfigurationSetsSes,
  getSesDataIsSubmitted,
  (confSets, dataIsSubmitted) => {
    return confSets.map((conf) => dataIsSubmitted && conf === '');
  },
);
